import React, { Component } from 'react'
import moment from 'moment';
import { QRCodeSVG } from 'qrcode.react';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";
const xml2js = require('xml-js');

class CreditNoteOfCancelation extends Component {

    render() {
        const { DocLines, DocHeader, EditableDocModel, EditableMode, BillAddress, ShipAddress, EditParam1, user, InfoByFolio, reprint, time } = this.props;

        let linesForAllInOne = 10;
        let linesfirstPage = 51;
        let linesfullPage = 71;

        let remainingLines = (DocLines.length - linesfirstPage) - (linesfullPage * Math.trunc((DocLines.length - linesfirstPage) / linesfullPage));
        let totalPages = Math.ceil((DocLines.length - linesfirstPage) / linesfullPage);

        let countLines = 1;
        let countLines2 = 1;

        let extraTables = [];

        for (let index = 0; index < totalPages; index++) {
            extraTables.push(this.ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, index, InfoByFolio.folio))
        }
        
        let XML = {};
        let xml = DocHeader.U_FMB_SELLO_CAN_SAT ? DocHeader.U_FMB_SELLO_CAN_SAT.includes('UUID') ?DocHeader.U_FMB_SELLO_CAN_SAT : null : null;
        XML = {
            isTimbra: xml ? true : false,
            info: xml
        }
        if(xml){
            let body = xml.toString();
            body = xml2js.xml2json(body, {compact: true, spaces: 4});
        }

       

        return (
            <>
                <table><tr><td>
                    <div id="printInvoice" >
                        <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                            <div className="row">
                                <div className="col-3">
                                    <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                                </div>
                                <div className="col-6 text-center">
                                    <h4><strong>Acuse de cancelación</strong></h4>
                                </div>
                                <div className="col-3">
                                </div>
                            </div>
                            <br />
                            <div className='row mt-3'>
                                <div className='col-4'>
                                    <span>Usuario: </span>
                                    <span>{DocHeader && DocHeader.CardCode}</span><br />
                                    <span>{DocHeader && DocHeader.CardName}</span>
                                </div>
                                <div className='col-2'></div>
                                <div className='col-3'>
                                    <span>{user.Branch.CodeBranchOffice +" - "+ user.Sucursal}</span>
                                </div>
                                <div className='col-2'></div>
                            </div>
                            <div className='row mt-3'>
                                <div className='col-12'>
                                    <span><strong>Fecha y hora de solicitud: </strong>{DocHeader && moment(DocHeader.DocDate).format("YYYY-MM-DD")}</span><br />
                                    <span><strong>Fecha y hora de cancelación: </strong>{!!InfoByFolio ? InfoByFolio.docTime.toString().length > 4 ? InfoByFolio.docTime : moment(InfoByFolio.docTime).format('LT') : ''}</span><br />
                                    <span><strong>RUT Emisor: </strong>{DocHeader && DocHeader.LicTradNum}</span>
                                </div>
                            </div>
                            <div className='row mt-3' style={{ paddingRight: "15px" }}>
                                <div className='col-12'>
                                    <table style={{ border: "solid 1px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ width: "12vw" }}></th>
                                                <th className="text-center" >Folio Fiscal</th>
                                                <th className="text-center">Estado CFDI</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th style={{ width: "12vw" }}></th>
                                                <td className="text-center ml-3 mr-3">9176B43B6-704C-42C6-9A87-C954354C00DD</td>
                                                <td className="text-center ml-3 mr-3" style={{ fontStyle: "italic" }}>Cancelado</td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td colSpan="3" style={{ paddingLeft: "15px" }}><strong>Sello digital del SAT:</strong></td>

                                            </tr>
                                            <tr>
                                                <td colSpan="3" style={{ overflowWrap: "break-word", padding: "15px" }}>
                                                    QAJa5A4cTTC3osVywJWDcnC11Ylg1d8+lB85xqZsVzPnaVIn+Bg5PxA89+2w30SIW3pvtrnbKhfmQvrrhP/L8Dkm7l+PgygShgq4bYPuon0
                                                    Qxbw3npMXtA19/dLvohwR2D8OVeEYdutEWS7tCnEQlEy8lEF3s4xhHqh7zwJV60jTTCV0uYfI3Rf/Z/gynq2pQyC2Zj/KgDmVYX26eYXR7M
                                                    A0Mk1hAs7gHUhcr8/UxGwhFpZj4JDTh6MhiORs+zBq/lZ+xnrLVea6qOr9MIi0QUK8VaScMwNHSZ9UtZjMF8dGm48lkfTk2ivN/dWjQ1cPj
                                                    pQ==
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                        <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "87vw" }}>

                            <div className="row pt-5">
                                <div className="col-3">
                                    <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />

                                    <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />
                                        {/* <span className="text-center">{user.Timbra.RFC || ''}</span><br /> */}
                                        <strong>Nota de crédito Folio: {InfoByFolio.folio || ''}</strong></p>

                                    {/* <span className="text-left">Teléfono(s): {user.Branch.Phone || ''}</span> */}
                                    <span className="text-left">Teléfono(s): </span>
                                    {/* <p className="text-center"><br/>{user.Branch.Address || ''}</p> */}
                                    <p className="text-center"><br /></p>
                                    {/* <p style={{ fontSize:'11px' }}>COL. C.P.;,.</p> */}
                                </div>
                                <div className="col-9">
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-center">Serie</th>
                                                <th className="text-center">Folio</th>
                                                {/* <th className="text-center">Número de certificado:</th> */}
                                                <th className="text-center">Fecha - Hora emisión</th>
                                                {/* <th className="text-center">Lugar de expedición</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">{!!DocHeader.Series && DocHeader.Series}</td>
                                                <td className="text-center">{!!DocHeader.DocNum && DocHeader.DocNum}</td>
                                                <td className="text-center">{!!DocHeader.DocDate && moment(DocHeader.DocDate).format('YYYY-MM-DD')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-center">No. Cliente:</th>
                                                <th className="text-center">Asesor de ventas</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">{DocHeader.CardCode ?? '' }</td>
                                                <td className="text-center">{DocHeader.SlpName || ''} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-center">Tipo Documento</th>
                                                <th className="text-center">Régimen</th>
                                                <th className="text-center">R.F.C.</th>
                                                <th className="text-center">Moneda</th>
                                                <th className="text-center">Folio</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">{!!DocHeader.ObjType && DocHeader.ObjType}</td>
                                                <td className="text-center">{!!DocHeader.U_FMB_REGIMEN_FISCAL && DocHeader.U_FMB_REGIMEN_FISCAL}</td>
                                                <td className="text-center">{!!DocHeader.LicTradNum && DocHeader.LicTradNum}</td>
                                                <td className="text-center">{CURRENCY ?? ''}</td>
                                                <td className="text-center">{InfoByFolio.folio || ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row' style={{ paddingRight: "15px" }}>
                            <label className="text-center" style={{fontSize: "14px"}}>{reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time}</>:""}</label>
                                <table>
                                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                        <tr>
                                            <th className="text-center" colSpan={2}>DOMICILIO DE FACTURACIÓN</th>
                                            <th className="text-center" colSpan={2} style={{ width: "18.75vw" }}>Forma y método de pago</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{ borderLeft: "solid 1px" }}>
                                            <td className="text-center" colSpan={2}>
                                                {EditableMode === false ?
                                                    (BillAddress === {} ?
                                                        (`${DocHeader.BillDirection}`)
                                                        :
                                                        (`${BillAddress.County ?? ''}, ${BillAddress.City ?? ''}, ${BillAddress.ZipCode ?? ''}, ${BillAddress.Block ?? ''}, ${BillAddress.Street ?? ''}`)
                                                    )
                                                    :
                                                    <>
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center">CALLE </th>
                                                                    <th className="text-center">ESTADO </th>
                                                                    <th className="text-center">CIUDAD </th>
                                                                    <th className="text-center">COLONIA </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr style={{ borderLeft: "solid 1px" }}>
                                                                    <td className="text-center">
                                                                        <input type="text"
                                                                            placeholder='CALLE'
                                                                            value={EditableDocModel.street ?? ''}
                                                                            onChange={(event) => this.OnchangeBillStreet(event.target.value)}
                                                                        >
                                                                        </input>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <input type="text"
                                                                            placeholder='ESTADO'
                                                                            value={EditableDocModel.county}
                                                                            onChange={(event) => this.OnchangeBillCounty(event.target.value)}
                                                                        >
                                                                        </input>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <input type="text" placeholder='CIUDAD'
                                                                            value={EditableDocModel.city}
                                                                            onChange={(event) => this.OnchangeBillCity(event.target.value)}
                                                                        ></input>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <input type="text" placeholder='COLONIA'
                                                                            value={EditableDocModel.block}
                                                                            onChange={(event) => this.OnchangeBillBlock(event.target.value)}
                                                                        ></input></td>

                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </>
                                                }
                                            </td>
                                            <td className="text-center" style={{ border: "solid 1px" }}>{!!DocHeader.U_FMB_FORMA_PAGO && DocHeader.U_FMB_FORMA_PAGO}</td>
                                            <td className="text-center" style={{ border: "solid 1px" }}>{!!DocHeader.U_FMB_METODO_PAGO && DocHeader.U_FMB_METODO_PAGO}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table>
                                    <thead>
                                        <tr style={{ borderLeft: "solid 1px" }}>
                                            <th className="text-center" style={{ width: "300px", background: Datos_Empresa.BackgroundColor, color: "white" }}>Fecha de vencimiento</th>
                                            <th className="text-center" style={{ width: "300px", background: Datos_Empresa.BackgroundColor, color: "white" }}>Nombre del capturista</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{ borderLeft: "solid 1px", borderBottom: "solid 1px" }}>
                                            <td className="text-center" style={{ border: "solid 1px" }}>{!!DocHeader.DocDueDate && moment(DocHeader.DocDueDate).format("YYYY-MM-DD")}</td>
                                            <td className="text-center" style={{ border: "solid 1px" }}>{DocHeader.U_FMB_User || ''}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className='mt-2'>
                                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                        <tr>
                                            <th>Cant.</th>
                                            <th>UMV</th>
                                            <th>CVE</th>
                                            <th>Cve P/S</th>
                                            <th className="text-center">Código</th>
                                            <th className="text-center">Descripción</th>
                                            <th className="text-center">Tasa</th>
                                            <th className="text-right">Precio U</th>
                                            <th className="text-right">Importe</th>
                                            {/* <th className="text-center">Descuento %</th> */}
                                            <th className="text-right">Importe N.</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ border: "solid 1px" }}>
                                        {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                            DocLines.map((docLine) => {//51 es el limite de la primera pagina
                                                if (countLines < 52) {
                                                    countLines++
                                                    return (
                                                        <tr style={{ fontSize: '12px' }}>
                                                            <td>{Number(docLine.Quantity).toFixed(4) ?? ''}</td>
                                                            <td>{docLine.SalUnitMsr ?? ''}</td>
                                                            <td>{docLine.U_FMB_UM_SAT ?? ''}</td>
                                                            <td>{docLine.U_FMB_CLAVE_SAT ?? ''}</td>
                                                            <td className="text-center">{docLine.ItemCode ?? ''}</td>
                                                            <td className="text-center">{docLine.Dscription.substring(0, 35) ?? ''}</td>
                                                            <td className="text-center">{Number(docLine.VatPrcnt).toFixed(0) ?? ''}</td>
                                                            <td className="text-right">{FORMAT_NUMBER.new(docLine.Price) ?? ''}</td>
                                                            <td className="text-right">{FORMAT_NUMBER.new(docLine.Quantity * docLine.Price) ?? ''}</td>
                                                            {/* <td className="text-center">{Number(docLine.DiscPrcnt).toFixed(0) ?? 0}%</td> */}
                                                            <td className="text-right">{FORMAT_NUMBER.new(docLine.LineTotal ?? 0)}</td>
                                                        </tr>
                                                    );
                                                } else {
                                                    return ("");
                                                }
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>

                            <div className='row mt-2'>
                                <div className='col-8'>
                                    <p style={{ marginLeft: "-13px", fontSize: '12px' }}>
                                        Comentarios: {DocHeader.Comments || ""} <br />
                                    </p>
                                </div>
                                <div className='col-4'>
                                    <table>
                                        <tbody style={{ fontSize: '12px' }}>
                                            <tr>
                                                <td className='text-right'><strong>Subtotal: </strong></td>
                                                <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "6.25vw" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</td>
                                            </tr>

                                            <tr>
                                                <td className='text-right'><strong>IVA: </strong></td>
                                                <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                            </tr>

                                            <tr>
                                                <td className='text-right'><strong>Total: </strong></td>
                                                <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal) ?? ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>




                        </div>
                    </div>
                </td></tr></table>

            </>
        )
    }
}

export default CreditNoteOfCancelation